import { Reveal } from "../../components/Reveal";
import { PageHero, CtaBand } from "../../components/ui";
import { LEADERSHIP } from "../../data/site";

export default function Leadership() {
    return (
        <>
            <PageHero
                eyebrow="Company — Senior Leadership Team"
                lines={["Led by developers.", "Accountable to the long term."]}
                trail={[{ label: "Home", path: "/" }, { label: "Company" }, { label: "Senior Leadership Team" }]}
            />
            <section className="bg-paper">
                <div className="container-x py-20 sm:py-24 lg:py-28">
                    <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
                        {LEADERSHIP.map((p, i) => (
                            <Reveal key={p.role} delay={i * 0.08}>
                                <article
                                    className={`flex h-full flex-col items-start border p-8 sm:p-10 ${
                                        p.placeholder ? "border-dashed border-line-2 bg-transparent" : "border-line bg-white"
                                    }`}
                                    data-testid={`leader-card-${i + 1}`}
                                >
                                    <div
                                        className={`flex aspect-square w-32 items-center justify-center rounded-full ${
                                            p.placeholder
                                                ? "border border-dashed border-line-2 bg-paper"
                                                : "bg-navy"
                                        }`}
                                        aria-hidden="true"
                                    >
                                        {p.placeholder ? (
                                            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-ink-3">
                                                To be<br />inserted
                                            </span>
                                        ) : (
                                            <span className="font-display text-3xl font-bold tracking-[0.06em] text-white">
                                                {p.initials}
                                            </span>
                                        )}
                                    </div>
                                    <h3 className="mt-8 font-display text-xl font-bold text-ink">
                                        {p.placeholder ? "Chief Financial Officer" : p.name}
                                    </h3>
                                    <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.18em] text-ink-3">
                                        {p.role}
                                    </p>
                                    {p.placeholder && (
                                        <p className="body-sm mt-6">Appointment to be announced.</p>
                                    )}
                                </article>
                            </Reveal>
                        ))}
                    </div>
                    <Reveal delay={0.15}>
                        <p className="body-sm mt-10 max-w-2xl">
                            Leadership photography and full biographies will be published here as
                            they are approved. Portraits are intentionally replaced with a consistent
                            monogram treatment until then.
                        </p>
                    </Reveal>
                </div>
            </section>
            <CtaBand />
        </>
    );
}
